/**
 * @description General Dropdown
 */

/* global polyfillsIE */

(() => {
	// FUNCTION
	const dropdown = () => {
		document
			.querySelectorAll('[data-js-dropdown-toggle]')
			.forEach((element) => {
				element.addEventListener('click', () => {
					element.classList.toggle('active');
					element.classList.contains('active')
						? element.setAttribute('aria-expanded', true)
						: element.setAttribute('aria-expanded', false);
					element.nextElementSibling.classList.toggle('active');
				});
			});
	};

	// GO après chargement 🚀
	window.addEventListener('load', () => {
		polyfillsIE();
		dropdown();
	});
})();
